import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

// 创建上下文
const AlertContext = createContext();

// 提供者组件
export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: 'info', // 'success', 'error', 'warning', 'info'
  });

  const showAlert = (message, severity = 'info') => {
    setAlert({
      open: true,
      message,
      severity,
      position: { vertical: 'top', horizontal: 'center' },
    });
  };

  const handleClose = () => {
    setAlert((prev) => ({
      ...prev,
      open: false,
    }));
  };

  return (
    <AlertContext.Provider value={showAlert}>
      {children}
      <Snackbar  anchorOrigin={alert.position} open={alert.open} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={alert.severity} sx={{ width: '100%' }}>
          {alert.message}
        </Alert>
      </Snackbar>
    </AlertContext.Provider>
  );
};

// 使用钩子
export const useAlert = () => {
  return useContext(AlertContext);
};